(() => {
  const LABELS = {
    seo: { technical: 'Technical SEO', onpage: 'On-page', content: 'Content quality', authority: 'Link authority', schema: 'Structured data', performance: 'Performance' },
    geo: { citability: 'AI citability', eeat: 'E-E-A-T', technical: 'Technical', schema: 'Structured data', brand: 'Brand signals', platform: 'Platform presence' }
  };
  const PATHS = { seo: { start: '/seo-audit', status: '/seo-audit/status/', pdf: '/seo-audit/download/' }, geo: { start: '/audit', status: '/audit/status/', pdf: '/audit/download/' } };
  const SAMPLES = {
    seo: { score: 78, scores: { technical: 82, onpage: 74, content: 70, authority: 61, schema: 92, performance: 88 },
      criticalIssues: ['14 product pages have no meta description', 'Mobile LCP is 3.4 s — above the 2.5 s target', 'Collection pages share duplicate title tags'],
      quickWins: ['Add alt text to 38 product images', 'Add Product schema with price and reviews', 'Serve hero images as WebP'] },
    geo: { score: 64, scores: { citability: 58, eeat: 66, technical: 81, schema: 72, brand: 47, platform: 55 },
      criticalIssues: ['Product pages have no clear answers AI assistants can quote', 'robots.txt blocks GPTBot and PerplexityBot on key pages', 'Brand is barely mentioned on review sites and forums AI learns from'],
      quickWins: ['Add FAQ blocks with FAQPage schema to top products', 'Publish an About page with founder, company and contact facts', 'Allow AI crawlers in robots.txt and add llms.txt'] }
  };
  const rate = (s) => (s >= 90 ? 'EXCELLENT' : s >= 75 ? 'GOOD' : s >= 60 ? 'FAIR' : s >= 40 ? 'POOR' : 'CRITICAL');
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const init = (root) => {
    const s = root.querySelector('[data-leo-audit]');
    if (!s || s.dataset.ready) return;
    s.dataset.ready = '1';
    const $ = (q) => s.querySelector(q);
    const tabs = [...s.querySelectorAll('[data-au-tab]')];
    const scan = $('[data-au-panel="scan"]');
    const plan = $('[data-au-panel="plan"]');
    const form = $('[data-au-form]');
    const input = $('[data-au-input]');
    const run = $('[data-au-run]');
    const err = $('[data-au-err]');
    const status = $('[data-au-status]');
    const bar = $('[data-au-bar]');
    const pct = $('[data-au-pct]');
    const stepsEl = $('[data-au-steps]');
    const steps = [...s.querySelectorAll('[data-au-step]')];
    const report = $('[data-au-report]');
    const pdf = $('[data-au-pdf]');
    const limitDays = parseFloat(s.dataset.limitDays || '0');
    let tool = s.dataset.tool || 'seo';
    let poll = null; let fake = null;
    const setTool = (t) => {
      tool = t;
      tabs.forEach((b) => { const on = b.dataset.auTab === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
      scan.hidden = t === 'plan'; plan.hidden = t !== 'plan';
      s.classList.toggle('is-plan', t === 'plan');
      $('[data-au-runlabel]').textContent = t === 'geo' ? 'Run GEO audit' : 'Run SEO audit';
      $('[data-au-url]').textContent = 'step-media.com/tools/' + (t === 'plan' ? 'marketing-plan' : t + '-audit');
      queueMicrotask(() => showView(t));
    };
    tabs.forEach((b) => b.addEventListener('click', () => setTool(b.dataset.auTab)));
    setTool(tool);
    const planForm = $('[data-au-plan]');
    const planErr = $('[data-au-planerr]');
    const planState = $('[data-au-state]');
    const payBtn = $('[data-au-paybtn]');
    const showState = (ok) => {
      if (!planState) return;
      planForm.hidden = true;
      planState.hidden = false;
      planState.innerHTML = ok
        ? '<span class="leo-au__stateicon">✓</span><h3 class="leo-h leo-h--4">Payment received — your audit is on its way</h3><p>Your 30-day plan will be in your inbox in 10–15 minutes. Check the spam folder if you don’t see it.</p>'
        : '<span class="leo-au__stateicon is-warn">!</span><h3 class="leo-h leo-h--4">Payment cancelled</h3><p>No charge was made. You can try again whenever you’re ready.</p><button type="button" class="leo-btn leo-btn--ghost" data-au-retry>Try again →</button>';
      const retry = planState.querySelector('[data-au-retry]');
      if (retry) retry.addEventListener('click', () => { planState.hidden = true; planForm.hidden = false; });
    };
    const payment = new URLSearchParams(location.search).get('payment');
    if (payment === 'success' || payment === 'cancelled') {
      setTool('plan'); showState(payment === 'success');
      history.replaceState({}, '', location.pathname + location.hash);
      setTimeout(() => s.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
    }
    if (planForm) planForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      planErr.hidden = true;
      const f = new FormData(planForm);
      let url = String(f.get('url') || '').trim();
      if (!url || !f.get('email') || !f.get('store_niche') || !f.get('main_challenge')) { planErr.textContent = 'Please fill in all four fields.'; planErr.hidden = false; return; }
      if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
      const base = (planForm.getAttribute('action') || '').replace(/\/(create-checkout|market-audit)\/?$/, '');
      const label = payBtn.innerHTML;
      payBtn.disabled = true; payBtn.textContent = 'Redirecting to secure payment…';
      try {
        const r = await fetch(base + '/create-checkout', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url, email: f.get('email'), store_niche: f.get('store_niche'), main_challenge: f.get('main_challenge') }) });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || !d.checkoutUrl) throw new Error(d.error || 'Could not start the payment. Please try again.');
        if (window.gtag) gtag('event', 'begin_checkout', { item_name: '30-day marketing plan' });
        window.location.href = d.checkoutUrl;
      } catch (x) {
        payBtn.disabled = false; payBtn.innerHTML = label;
        planErr.textContent = x.message && x.message.length < 160 ? x.message : 'Could not start the payment. Please try again.';
        planErr.hidden = false;
      }
    });
    const showErr = (m) => { err.textContent = m; err.hidden = !m; };
    const setProgress = (p, label) => { bar.style.width = p + '%'; pct.textContent = Math.round(p) + '%'; if (label) status.textContent = label; };
    const setStep = (i) => steps.forEach((st, k) => { st.classList.toggle('is-done', k < i); st.classList.toggle('is-on', k === i); });
    const render = (d, jobId, sample) => {
      const score = Math.round(d.score || 0);
      $('[data-au-score]').textContent = score;
      $('[data-au-ring]').style.setProperty('--v', score);
      $('[data-au-rating]').textContent = (tool === 'geo' ? 'AI VISIBILITY' : 'SEO SCORE') + ' · ' + rate(score);
      const labels = LABELS[tool];
      const cats = Object.entries(d.scores || {}).map(([k, v]) => {
        const val = Math.round(typeof v === 'object' && v !== null ? (v.score ?? 0) : v);
        return `<div class="leo-au__cat"><span>${esc(labels[k] || k)}</span><i><b style="--w:${val}%" class="${val >= 75 ? 'is-good' : val < 50 ? 'is-low' : ''}"></b></i><em class="leo-mono">${val}</em></div>`;
      }).join('');
      $('[data-au-cats]').innerHTML = cats;
      const li = (arr) => (arr || []).slice(0, 5).map((x) => `<li>${esc(typeof x === 'string' ? x : (x.title || x.issue || x.text || JSON.stringify(x)))}</li>`).join('');
      $('[data-au-issues]').innerHTML = li(d.criticalIssues) || '<li>No critical issues found</li>';
      $('[data-au-wins]').innerHTML = li(d.quickWins) || '<li>Nothing quick left — nice work</li>';
      const pt = s.querySelector('[data-au-pdftitle]'); if (pt) pt.textContent = tool === 'geo' ? 'GEO AUDIT REPORT' : 'SEO AUDIT REPORT';
      const ps = s.querySelector('[data-au-pdfscore]'); if (ps) ps.textContent = score;
      if (sample) { pdf.setAttribute('aria-disabled', 'true'); } else { pdf.href = (tool === 'geo' ? s.dataset.geoApi : s.dataset.seoApi) + PATHS[tool].pdf + encodeURIComponent(jobId); pdf.setAttribute('aria-disabled', 'false'); }
      report.classList.remove('is-loading');
    };
    const results = { seo: null, geo: null };
    const showView = (t) => {
      if (t === 'plan' || run.disabled) return;
      const res = results[t];
      const sampleTag = s.querySelector('[data-au-sample]');
      if (res) { render(res.d, res.jobId); if (sampleTag) sampleTag.hidden = true; }
      else { render(SAMPLES[t], null, true); if (sampleTag) sampleTag.hidden = false; }
    };
    const finish = () => { clearInterval(poll); clearInterval(fake); run.disabled = false; };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      showErr('');
      let url = input.value.trim().replace(/^https?:\/\//i, '').replace(/\/$/, '');
      if (!/^[a-z0-9-]+(\.[a-z0-9-]+)+(\/.*)?$/i.test(url)) { showErr('Enter your store address, e.g. yourstore.com'); input.focus(); return; }
      const key = 'leo_audit_' + tool;
      try { const last = parseInt(localStorage.getItem(key) || '0', 10); if (limitDays > 0 && last && Date.now() - last < limitDays * 864e5) { const left = Math.ceil((limitDays * 864e5 - (Date.now() - last)) / 864e5); showErr(`You’ve already run a free ${tool.toUpperCase()} audit recently. Try again in ${left} day${left > 1 ? 's' : ''}.`); return; } } catch (x) {}
      s.classList.add('is-live');
      $('[data-au-sample]').hidden = true;
      run.disabled = true; stepsEl.hidden = false; report.classList.add('is-loading'); pdf.setAttribute('aria-disabled', 'true');
      let p = 2; setStep(0); setProgress(p, 'STARTING · ' + url.toUpperCase());
      fake = setInterval(() => { p = Math.min(92, p + (92 - p) * 0.06); setStep(Math.min(3, Math.floor(p / 25))); setProgress(p, 'WORKING · ' + steps[Math.min(3, Math.floor(p / 25))].textContent.replace(/^\s*\d+\s*/, '')); }, 1000);
      const api = tool === 'geo' ? s.dataset.geoApi : s.dataset.seoApi;
      try {
        const r = await fetch(api + PATHS[tool].start, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url: 'https://' + url }) });
        const d = await r.json();
        if (!d.jobId) throw new Error(d.error || 'The audit could not start.');
        try { localStorage.setItem(key, String(Date.now())); } catch (x) {}
        poll = setInterval(async () => {
          try {
            const st = await (await fetch(api + PATHS[tool].status + encodeURIComponent(d.jobId))).json();
            if (st.status === 'done') { finish(); setStep(4); setProgress(100, 'REPORT READY · ' + url.toUpperCase()); results[tool] = { d: st, jobId: d.jobId }; render(st, d.jobId); if (window.gtag) gtag('event', 'audit_completed', { tool }); }
            else if (st.status === 'error') { finish(); setProgress(0, 'AUDIT STOPPED'); showErr(st.error || 'The audit couldn’t finish. Try again or message us.'); report.classList.remove('is-loading'); }
          } catch (x) {}
        }, 5000);
      } catch (x) {
        finish(); setProgress(0, 'AUDIT STOPPED'); report.classList.remove('is-loading');
        showErr(x.message && x.message.length < 140 ? x.message : 'The audit couldn’t finish. Try again or message us.');
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();